import { jsx } from 'react/jsx-runtime';
import React, { Suspense } from 'react';
import { ErrorBoundary } from '../../components/ErrorBoundary.js';
import { useInitializeVisualEditor } from '../../hooks/useInitializeVisualEditor.js';

const VisualEditorLoader = React.lazy(() => import('./VisualEditorLoader.js'));
const VisualEditorRoot = ({ visualEditorMode, experience, initialLocale, }) => {
    const initialEntities = experience?.entityStore?.entities || [];
    useInitializeVisualEditor({
        initialLocale,
        initialEntities,
    });
    return (jsx(ErrorBoundary, { children: jsx(Suspense, { fallback: jsx("div", { children: "Loading..." }), children: jsx(VisualEditorLoader, { experience: experience, visualEditorMode: visualEditorMode }) }) }));
};

export { VisualEditorRoot, VisualEditorRoot as default };
//# sourceMappingURL=VisualEditorRoot.js.map
